

import { useState } from "react";
import { TimeFilter } from "@/types";
import { cn } from "@/lib/utils";
import { useInstallEventsAggregation } from "@/hooks/useInstallEventsAggregation";
import { getAuth } from "firebase/auth";

const FILTERS: TimeFilter[] = ["today", "7d", "30d", "lifetime"];

export function EarningsSummaryCard() {
  const [activeFilter, setActiveFilter] = useState<TimeFilter>("today");
  const auth = getAuth();
  const userId = auth.currentUser?.uid;
  
  const { totalEarnings, loading } = useInstallEventsAggregation(userId, activeFilter);

  return (
    <div className="rounded-3xl border border-white/10 bg-gradient-to-br from-lime-400/20 via-emerald-500/10 to-zinc-900 p-5 text-white">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-white/70">
            {activeFilter === "today" ? "Today" : activeFilter === "7d" ? "Last 7 days" : activeFilter === "30d" ? "Last 30 days" : "Lifetime"} earnings
          </p>
          <p className="text-4xl font-semibold">
            {loading ? "..." : `$${totalEarnings.toFixed(2)}`}
          </p>
        </div>
        <div className="flex gap-2 text-xs">
          {FILTERS.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={cn(
                "rounded-full px-3 py-1 capitalize",
                activeFilter === filter
                  ? "bg-white text-black"
                  : "bg-white/10 text-white/70"
              )}
            >
              {filter}
            </button>
          ))}
        </div>
      </div>
      <p className="mt-2 text-xs text-white/70">
        Earnings from all accounts and campaigns.
      </p>
    </div>
  );
}
